import { cn } from "@/lib/utils";

interface CommunityWordmarkProps {
  className?: string;
}

export function CommunityWordmark({ className }: CommunityWordmarkProps) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        "inline-flex items-center justify-center border-2 border-retro-line bg-retro-paper font-mono font-black uppercase leading-none text-brand-green",
        className,
      )}
    >
      Community
    </span>
  );
}
